export const environment = {
  production: true,
  apiUrl : 'https://dev.api.salonpartner.cloud/',
  helpdeskNumber: '01268 762 888',
  ExceptionlessApiKey : "h12WmlIhmxgWWKzeeg8XqRSywxfWMMhFNpoWqzGT",
  KENDO_UI_LICENSE : ""
};
